<template>
  <input @click.prevent="$emit('click')" type="submit" :disabled="disabled" class="w-full button button--red" :value="label" />
</template>

<script>
export default {
  name: 'SubmitButton',
  props: {
    label: {
      type: String,
      default: 'Submit'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: [
      'click'
  ]
}
</script>